<template>
    <div>
        <div class="merchant-cont scroll-box-x">
            <div class="spec-item" >
                <img class="special" src="@/assets/images/special.png" alt="special">
                <img class="discount" src="@/assets/images/discount.png" alt="discount">
            </div>
            <div class="scroll-box">
                <!-- swiper 部分 -->
                <swiper :options="swiperOption" ref="mySwiper" id="spec-swiper" >
                    <swiper-slide v-for="item in offmerchantList" :key="item.merchantId" class="merchant-item" >
                        <div @click="goMerchant(item)">
                            <div class="img-box" :style="{ 'background-image': `url(${item.webmerchantLogo})` }" ></div>
                            <div class="info-box" >
                                <div class="title" >{{ item.restaurantName }}</div>
                                <div class="cuisines">{{ item.cuisines }}</div>
                                <div class="rate" >
                                    <el-rate style="position: relative;top:2px;" v-model="item.tasteRating" :disabled="true" :colors="['#aa0bc0','#aa0bc0','#aa0bc0','#aa0bc0','#aa0bc0']"
                                    disabled-void-color="#CFC9C3"></el-rate>
                                    (<span> {{ item.tasteRating }} </span>)
                                </div>
                                <div class="discount-tag" >
                                    {{ item.merchantOff }} %
                                </div>
                                <div class="n-item">
                                    <i class="el-icon-time" ></i>
                                    <span class="spend-time">{{ item.merchantDeliveryEstimation?item.merchantDeliveryEstimation:'-' }}</span>
                                </div>
                                <div class="n-item">
                                    <i class="el-icon-location" ></i>
                                    <span class="distance">{{ item.deliveryDistance.replace('mi', 'miles').replace('null', '-') }}</span>
                                </div>
                                <div :class="['status-tag', {'status-close':item.merchantCloseStore}]" >{{ item.merchantCloseStore?'Closed':'Open' }}</div>
                            </div>
                            <div class="card-footer">
                                <span v-if="item.delivery">
                                    Delivery <i class="el-icon-success" ></i>
                                </span>
                                <span v-if="item.pickup">
                                    Pick-up <i class="el-icon-success" ></i>
                                </span>
                                <span v-if="item.dinein">
                                    Dine-in <i class="el-icon-success" ></i>
                                </span>
                                <span v-if="item.preorder">
                                    Pre-order <i class="el-icon-success" ></i>
                                </span>
                            </div>
                        </div>
                    </swiper-slide>

                    <!-- 可选的控件 -->
                    <!--前进后退按钮-->
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>

        <h2 class="page-title" >Tops Restaurants near by you</h2>

        <div class="merchant-cont merchant-cont-normal" >
            <div v-for="item in merchantList" :key="item.merchantId" class="merchant-item" @click="goMerchant(item)">
                <div class="img-box" :style="{ 'background-image': `url(${item.webmerchantLogo?item.webmerchantLogo:merchantDefaultImg})` }" ></div>
                <div class="info-box" >
                    <div class="title" >{{ item.restaurantName }}</div>
                    <div class="cuisines">{{ item.cuisines }}</div>
                    <div class="rate" >
                        <el-rate v-model="item.tasteRating" style="position: relative;top:2px;" :disabled="true" :colors="['#aa0bc0','#aa0bc0','#aa0bc0','#aa0bc0','#aa0bc0']"
                         disabled-void-color="#CFC9C3"></el-rate>
                         (<span> {{ item.tasteRating }} </span>)
                    </div>
                    <div class="n-item">
                        <i class="el-icon-time" ></i>
                        <span class="spend-time">{{ item.merchantDeliveryEstimation?item.merchantDeliveryEstimation:'-' }}</span>
                    </div>
                    <div class="n-item">
                        <i class="el-icon-location" ></i>
                        <span class="distance">{{ item.deliveryDistance.replace('mi', 'miles').replace('null', '-') }}</span>
                    </div>
                    <div :class="['status-tag', {'status-close':item.merchantCloseStore}]" >{{ item.merchantCloseStore?'Closed':'Open' }}</div>
                </div>
                <div class="card-footer">
                    <span v-if="item.delivery">
                        Delivery <i class="el-icon-success" ></i>
                    </span>
                    <span v-if="item.pickup">
                        Pick-up <i class="el-icon-success" ></i>
                    </span>
                    <span v-if="item.dinein">
                        Dine-in <i class="el-icon-success" ></i>
                    </span>
                    <span v-if="item.preorder">
                        Pre-order <i class="el-icon-success" ></i>
                    </span>
                </div>
            </div>
            <br />
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            merchantList: {
                type: Array,
                default: ()=>[]
            },
            offmerchantList: {
                type: Array,
                default: ()=>[]
            },
        },
        data() {
            return {
                merchantDefaultImg: 'https://nweb.alleatapp.com/food/img/20220709/7A135E7287DA4583507C81484A9A7695.jpeg',
                transTypeList: ['Delivery', 'Pick-up','Dine-in','Pre-order'],
                swiperOption: {
                    //幻灯片放映方向
                    direction: "horizontal", //通常不与左右按钮一同使用
                    slidesPerView: 3,
                    spaceBetween: 20,
                    //分页器配置项
                    pagination: {
                        el: ".swiper-pagination", //分页器的类名
                        clickable: true, // 点击分页器跳切换到相应的幻灯片
                        bottom: 0,
                    },
                    //前进后退按钮
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    //幻灯片播放配置项
                    loop: false, //是否循环播放
                    speed: 1000, // 发生页面切换动画时，动画的切换速度
                    autoplay: false,
                    breakpoints: {
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                        },
                    },
                    on: {
                        click: function () {
                            // let dataset = event.target.dataset
                            // console.log(this.activeIndex); //每次切换结束时，在控制台打印现在是第几个slide
                        },
                    },
                },
            }
        },
        mounted() {

        },
        methods: {
            goMerchant(item) {
                console.log(item, 'item')
                this.$router.push({
                    path: '/menu-' + item.restaurantSlug
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
.page-title {
    font-weight: 700;
    color: #000;
    font-size: 30px;
    margin: 5px 0 20px 0;
}
.swiper-button-next, .swiper-button-prev {
    background: rgba(185, 185, 185, 0.25);
    transition: all ease-in-out .2s;
    &:hover {
        background: rgb(201, 199, 199);
        color: #fff;
    }
}

// .merchant-cont-normal {
//     .merchant-item:nth-child(4n) {
//         margin-right: 0;
//     }
// }
.merchant-cont {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    justify-content: flex-start;
    font-family: 'Roboto';
    
    .merchant-item {
        min-height: 280px;
        max-height: 320px;
        min-width: 270px;
        max-width: 270px;
        margin: 0 20px 15px 0;
        background-color: #fff;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
        border-radius: 8px;
        display: inline-flex;
        overflow: hidden;
        flex-direction: column;
        cursor: pointer;
        transition: all ease-in-out .2s;

        &:hover {
            box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.65);
        }

        .img-box {
            height: 150px;
            width: 100%;
            overflow: hidden;
            background-position: center;
            background-size: cover;
            border-radius: 8px 8px 0 0;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
            }
        }
        .info-box {
            padding: 5px 10px;
            color: #000;
            flex: 1;
            position: relative;

            .status-tag {
                position: absolute;
                bottom: 4px;
                right: 4px;
                background: #428600;
                font-weight: 600;
                color: #fff;
                height: 25px;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                width: 64px;
            }
            .status-close {
                background: #E9E9E9;
                color: #939393;
            }

            .title {
                font-weight: 600;
                font-size: 16px;
                word-break: break-all;
                white-space: pre-wrap;
            }
            .cuisines {
                font-size: 11px;
                color: #333;
                margin: 2px 0 4px 0;
                word-break: break-all;
            }
            .discount-tag {
                margin-bottom: 4px;
                display: inline-block;
                padding: 4px 15px;
                background: #D61409;
                font-weight: 600;
                color: #fff;
                // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                border-radius: 5px 5px 0px 0px;
            }
            .n-item {
                margin: 2px 0;
                span {
                    font-size: 12px;
                }
                .spend-time {
                    font-size: 14px;
                    font-weight: 600;
                }
                i {
                    font-size: 15px;
                    margin-right: 6px;
                    font-weight: 600;
                }
                .el-icon-location {
                    color: #26d07c;
                }
            }
            .rate {
                display: flex;
                align-items: center;
                position: relative;
                left: -2px;
                top: -2px;
                font-size: 14px;

                span {
                    color: #FF8000;
                    font-weight: 500;
                    position: relative;
                }
            }
        }
        .card-footer {
            height: 32px;
            display: flex;
            align-items: center;
            border-top: 1px solid #0000006B;
            padding: 0 10px;
            font-size: 8px;
            span {
                margin-right: 6px;
                white-space: nowrap;
            }
            .el-icon-success {
                color: #26d07c;
                margin-left: -2px;
            }
        }
    }
    .spec-item {
        margin: 5px 15px 15px 0;
        height: 320px;
        width: 270px;
        min-width: 270px;
        overflow: hidden;
        display: inline-flex;
        flex-direction: column;
        justify-content: space-between;
        .special {
            width: 100%;
            margin-bottom: 6px;
        }
        .discount {
            width: 100%;
        }
    }
}
.scroll-box-x {
    flex-wrap: nowrap;
    .scroll-box {
        flex: 1;
        white-space: nowrap;
        overflow: auto;
        overflow-y: hidden;

        &::-webkit-scrollbar {
            display: none;
        }
        &::-webkit-scrollbar-thumb {
            display: none;
        }
        #spec-swiper {
            padding: 3px;
            min-height: 300px;
        }
    }
}
</style>